import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { DownloadCsv } from '../../../../../../../common/downloadCsv'
import { DownloadJpg } from '../../../../../../../common/downloadJpg'
import { UseI18n } from '../../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../../common/html/element'
import { Icon } from '../../../../../../../common/html/icon'
import { Loading } from '../../../../../../../common/loading'
import { Panel } from '../../../../../../../common/panel'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { Tooltip } from '../../../../../../../common/tooltip'
import { selectCompanyInfo } from '../../../../../../common/header/companyInfo/store/slice'
import { selectDistributionScore, selectLoading } from '../../../../store/slice'
import {
  downloadDistributionScore,
  getDistributionScoreThunk,
} from '../../../../store/thunk'
import { mapViewBy } from '../corporateRiskScore/constants'
import DistributionOfScoreChart from './DistributionOfScoreChart'
import DistributionOfScoreTable from './DistributionOfScoreTable'
import Filter from './Filter'
import { SCORE_TABS } from './constants'

const DistributionOfScore = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const label = UseI18n('distributionOfScore.title')
  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const locale = useSelector((state) => state.i18n.locale)
  const distributionScore = useSelector(selectDistributionScore)
  const loading = useSelector(selectLoading('distributionScore'))

  const [viewBy, setViewBy] = useState(mapViewBy.chart.value)
  const [sortBy, setSortBy] = useState(SCORE_TABS.byModelSegment.key)

  const handleChooseViewBy = (item) => {
    if (item.value !== viewBy) {
      setViewBy(item.value)
    }
  }

  const downloadCsv = () => {
    const mapKeyDownload = {
      modelSegment: 1,
      industry: 2,
      companySize: 3,
    }
    return downloadDistributionScore({
      OrganizationId: params.organizationId,
      OrderSort: mapKeyDownload[sortBy],
    })
  }

  useEffect(() => {
    dispatch(
      getDistributionScoreThunk({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale])

  const renderRightHeader = () => {
    return (
      <Element className="dFlex alignItemsCenter" style={{ color: '#3A414B' }}>
        <Translate value="financialAnalysis.VIEW_BY" />
        <SelectCustom
          isBorderNone
          isI18n
          activeItem={Object.values(mapViewBy).find(
            (item) => item.value === viewBy,
          )}
          data={Object.values(mapViewBy)}
          chooseItem={handleChooseViewBy}
        />
        {viewBy === mapViewBy.chart.value ? (
          <DownloadJpg
            data={{
              disabled: !distributionScore?.[sortBy]?.length,
              arrName: [
                label,
                UseI18n('score.main.DETAILS'),
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: label,
              domId: 'distributionOfScoreChartId',
            }}
          />
        ) : (
          <DownloadCsv downloadCsv={downloadCsv} disabled={false} />
        )}
      </Element>
    )
  }

  return (
    <Panel
      isI18n
      label="distributionOfScore.title"
      renderLabel={() => {
        return (
          <div>
            <Tooltip
              contentStyle={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 4,
              }}
              tooltipStyle={{
                maxWidth: 400,
              }}
              tooltipContent={
                <div className="textCenter" style={{ textAlign: 'justify' }}>
                  <Translate value="distributionOfScore.tooltip" />
                </div>
              }
            >
              <Icon
                className="icon-info-circle"
                style={{ fontSize: 16, color: '#9C9C9C' }}
              />
            </Tooltip>
          </div>
        )
      }}
      renderRightHeader={renderRightHeader}
    >
      <div style={{ padding: 12, position: 'relative', minHeight: 150 }}>
        <Filter sortBy={sortBy} setSortBy={setSortBy} />
        {loading ? (
          <div style={{ height: 200, position: 'relative' }}>
            <Loading />
          </div>
        ) : viewBy === mapViewBy.chart.value ? (
          <DistributionOfScoreChart sortBy={sortBy} />
        ) : (
          <DistributionOfScoreTable sortBy={sortBy} />
        )}
      </div>
    </Panel>
  )
}

export default DistributionOfScore
